
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  topic: string;
}

export const ImageModal = ({ isOpen, onClose, imageUrl, topic }: ImageModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-screen-lg w-[90vw] p-1">
        <div className="relative w-full h-[80vh]">
          <img
            src={imageUrl}
            alt={topic}
            className="w-full h-full object-contain"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
